import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import alertify from "alertifyjs";
import { AddUser } from "../../services/apiUtils";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const UserRegister = () => {
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    Phone: "",
    Address: "",
    City: "",
    State: "",
    location: "",
  });

  const [errors, setErrors] = useState({});
  const [UserId, setUserId] = useState();
  const history = useHistory();

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("user_id"));
    if (storedData) {
      setUserId(storedData);
    }
  }, []);

  const validateField = (name, value) => {
    if (name === "location") return "";

    let error = "";
    switch (name) {
      case "email":
        error = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ""
          : "Invalid email format";
        break;
      case "phone":
        error = /^\d{10}$/.test(value) ? "" : "Phone must be 10 digits";
        break;
      default:
        error = value.trim()
          ? ""
          : `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
    }
    return error;
  };

  const formHandler = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: validateField(name, value) });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setErrors({ ...errors, [name]: validateField(name, value) });
  };

  /**
   * Handles the form submission and validates the input data. If all inputs are
   * valid, it calls the `AddUser` API to add a new user and if successful,
   * redirects to the `/user` route. If any of the inputs are invalid, it sets the
   * corresponding error messages in the component state.
   * @param {React.FormEvent<HTMLFormElement>} e - The form event object.
   */
  const submitHandler = async (e) => {
    e.preventDefault();
    let formErrors = {};
    Object.keys(formData).forEach((key) => {
      formErrors[key] = validateField(key, formData[key]);
    });
    setErrors(formErrors);

    if (Object.values(formErrors).every((err) => err === "")) {
      try {
        console.log("Form Submitted:", formData);
        const FullData = {
          Created_by: UserId,
          Name: formData.Name.trim(),
          Email: formData.Email,
          Phone: formData.Phone,
          Address: formData.Address.trim(),
          City: formData.City.trim(),
          State: formData.State.trim(),
          GeoLocation: formData.location,
          Status: 1,
          // Password: "",
        };
        console.log("Full Data", FullData);

        const UserRegister = await AddUser(FullData);
        if (UserRegister.success === 200) {
          console.log("UserRegister", UserRegister);
          alertify.success("Registration Successful!");
          history.push("/user");
        } else {
          alertify.error("Api Error");
        }
      } catch (error) {
        console.log("error");
        alertify.error(error);
      }
    } else {
      alertify.error("Please fix the errors in the form");
    }
  };

  return (
    <div className="page-wrapper">
      <Header />
      <Sidebar />
      <div className="col-xl-6 d-flex user_edit">
        <div className="card flex-fill">
          <div className="card-header d-flex align-items-center justify-content-between">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => history.push("/user")}
            >
              ← Back
            </button>

            <h5 className="card-title text-uppercase m-0 flex-grow-1 text-center">
              User Registration
            </h5>

            {/* spacer to balance layout */}
            <div style={{ width: 60 }}></div>
          </div>
          <div className="card-body">
            <form onSubmit={submitHandler}>
              {Object.keys(formData).map((field) => (
                <div className="input-block mb-3 row" key={field}>
                  <label className="col-lg-3 col-form-label">
                    {field.charAt(0).toUpperCase() + field.slice(1)}
                  </label>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      name={field}
                      className="form-control"
                      value={formData[field]}
                      onChange={formHandler}
                      onBlur={handleBlur}
                      required
                      readOnly={field === "location"}
                    />
                    {errors[field] && (
                      <small className="text-danger">{errors[field]}</small>
                    )}
                  </div>
                </div>
              ))}
              <div className="text-end">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRegister;
